import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoDrawer from '../../components/drawer/pendo-drawer.vue.js';
import PendoTooltip from '../../directives/tooltip/tooltip.vue.js';
import get from 'lodash/get.js';

var script = {
  name: 'PendoSidePanelDrawer',
  components: {
    PendoButton,
    PendoDrawer
  },
  directives: {
    PendoTooltip
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: null
    },
    header: {
      type: Object,
      default: () => ({})
    },
    body: {
      type: Object,
      default: () => ({})
    },
    zIndex: {
      type: Number,
      default: 20000
    }
  },
  data() {
    return {
      overflowTooltipContent: this.headerTitleProp
    };
  },
  computed: {
    noComponentClass() {
      return this.header.component ? '' : 'pendo-side-panel-drawer--no-component';
    },
    headerTitleProp() {
      return get(this.header, 'props.title', '');
    }
  },
  methods: {
    checkForOverflowingContent(event, tooltipText) {
      const {
        scrollWidth,
        clientWidth
      } = event.target;
      this.overflowTooltipContent = scrollWidth > clientWidth ? tooltipText : null;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-side-panel-drawer.vue2.js.map
